<template>
    <main class="page__profile" role="main">
        <div class="o-wrapper">
            <div class="o-grid">
                <aside class="profile__sidebar o-grid__item u-width-3/12 u-width-full@m">
                    <div class="profile__sidebar__main">
                        <ul>
                            <!--<router-link tag="li" to="/about" exact-active-class="active"><a>About</a></router-link>-->
                            <router-link tag="li" to="/contact" exact-active-class="active"><a>Contact</a></router-link>
                            <router-link tag="li" to="/faqs" exact-active-class="active"><a>FAQs</a></router-link>
                            <router-link tag="li" to="/terms" exact-active-class="active"><a>Terms &amp; Conditions</a></router-link>
                            <router-link tag="li" to="/privacy" exact-active-class="active"><a>Privacy Policy</a></router-link>
                            <router-link tag="li" to="/cookies" exact-active-class="active"><a>Cookie Policy</a></router-link>
                        </ul>
                    </div>
                </aside>
                <div class="u-width-1/12"></div>
                <div class="o-grid__item u-width-8/12 u-width-full@s">
                    <div class="o-grid__item u-width-full@m">
                        <div class="o-grid profile__content">
                            <div class="o-grid__item u-width-10/12 u-width-full@s u-m-b4">
                                <div class="c-profile__header">
                                    <h1 class="u-m-b5 u-m-b2@s">Contact Us</h1>
                                </div>
                                <p v-if="success">Thank you for your comments - we'll be in touch soon.</p>
                                <p v-if="errors" class="error">There was an issue submitting the form - please see below.</p>
                                <p v-if="success === false && errors === false && $root.user !== false">Hey {{$root.user.firstName}}, we'd love you to voice your opinion. Have a great idea for a new {{ $root.brand.name }} community? Or just have a general question about the company? Feel free to get in touch below and we'll get back to you as soon as possible.</p>
                                <form v-if="success === false" class="u-width-full u-m-t3">
                                    <div class="c-profile__input-group u-width-10/12 u-width-full@s">
                                        <label for="name">Name</label>
                                        <input v-model="form.name" ref="name" class="c-textbox u-width-full" id="name">
                                        <span class="u-error-asterix" v-if="errors.name" v-html="Object.entries(errors.name).map(item => item[1])[0]"></span>
                                    </div>
                                    <div class="c-profile__input-group u-width-10/12 u-width-full@s">
                                        <label for="email">Email</label>
                                        <input v-model="form.email" ref="email" class="c-textbox u-width-full" id="email">
                                        <span class="u-error-asterix" v-if="errors.email" v-html="Object.entries(errors.email).map(item => item[1])[0]"></span>
                                    </div>
                                    <div class="c-profile__input-group u-width-10/12 u-width-full@s">
                                        <label for="comments">Comments</label>
                                        <textarea v-model="form.comments" ref="comments" class="c-textbox--contactus u-width-full" id="comments"></textarea>
                                        <span class="u-error-asterix" v-if="errors.comments" v-html="Object.entries(errors.comments).map(item => item[1])[0]"></span>
                                    </div>
                                    <button class="c-btn u-text-small u-p-x3 u-p-y1" @click.prevent="submit">Submit</button>
                                    <vue-recaptcha
                                        ref="invisRecaptcha"
                                        @verify="recaptchaVerify"
                                        @expired="recaptchaExpired"
                                        size="invisible"
                                        badge="bottomright"
                                        :loadRecaptchaScript="true"
                                        :sitekey="recaptchaSiteKey">
                                    </vue-recaptcha>
                                </form>
                                <div class="o-grid u-m-t10 u-m-t5@s u-m-b2">
                                    <div class="o-grid__item u-width-half">
                                        <h4>Address</h4>
                                        <p>{{ $root.brand.company }}<br>
                                            59 Mealough Road<br>
                                            Belfast<br>
                                            BT8 8LS<br>
                                            N. Ireland</p>
                                    </div>
<!--                                    <div class="o-grid__item u-width-half">
                                        <h4>Email</h4>
                                        <p><a href="mailto:support@dyadey.com">support@dyadey.com</a></p>
                                    </div>-->
                                </div>
                                <div class="c-profile__connect-social u-m-b6@s">
                                    <h4 class="u-m-t10 u-m-t3@s u-m-b2">Connect on social</h4>
                                    <div class="c-profile__connect-social-btns">
                                        <a href="https://www.facebook.com/dyadey" target="_blank"><img src="img/icons/icon-facebook-article.svg" alt="Connect via Facebook"></a>
                                        <a href="https://twitter.com/dyadey_" target="_blank"><img src="img/icons/icon-twitter-article.svg" alt="Connect via Twitter"></a>
                                        <a href="https://www.instagram.com/dyadey/" target="_blank"><img src="img/icons/icon-instagram-article.svg" alt="Connect via Twitter"></a>
                                        <a href="https://www.youtube.com/channel/UCUxyqxeim5H4ECqA4QFxVDg" target="_blank"><img src="img/icons/icon-youtube-article.svg" alt="Connect via YouTube"></a>
                                        <a href="mailto:info@dyadey.com"><img src="img/icons/icon-email-share-article.svg" alt="Connect via email"></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import { VueRecaptcha } from 'vue-recaptcha';

export default {
    components: {
        VueRecaptcha
    },
    data() {
        return {
            form: {
                name: '',
                email: '',
                comments: ''
            },
            success: false,
            errors: false,
            recaptchaSiteKey: this.$root.recaptchaSiteKey,
            recaptchaSuccess: false
        }
    },
    created() {
        let title = document.querySelector('title');
        title.innerText = 'Contact Us - ' + this.$root.brand.name;
    },
    watch: {
        '$route' (to, from) {
            this.path = this.$route.path;
            console.log('form', to, from);
        }
    },
    methods: {
        recaptchaVerify(response) {
            this.$http.post('/api/v1/recaptcha', {response: response})
                .then(response => {
                    this.recaptchaSuccess = !!response.data.success;
                    // if recaptcha fails do not allow form to be submitted
                    if (this.recaptchaSuccess === false) {
                        alert('We cannot submit the form at this time as you look like a bot - please try again');
                        return;
                    }
                    this.$http.post('/api/v1/contact', this.form)
                        .then(response => {
                                console.log(response.data);
                                this.success = response.data.success;
                                this.errors = response.data.errors;
                            }, response => {
                                console.log('Error:');
                                console.log(response);
                            }
                        );
                }, response => {
                    console.log('Error:');
                    console.log(response);
                });
        },
        recaptchaExpired() {
            console.log('Recaptcha expired');
        },
        submit() {
            for (let i in this.form) {
                if (this.form[i] === '') {
                    alert('Please complete ' + i + ' before submitting');
                    this.$refs[i].focus();
                    return false;
                }
            }
            const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (re.test(String(this.form.email).toLowerCase()) === false) {
                alert('Please use a valid email address');
                this.$refs.email.focus();
                return false;
            }
            // call recaptchaVerify() through execute() function
            this.$refs.invisRecaptcha.execute();
        }
    }
}
</script>
